<template>
    <select v-if="null != componentModel" :id="elementId" :class="cssClass" ref="select" v-model="componentModel[boundProperty]">
        <option v-for="[code, stateName] of Object.entries(states)" :key="code" :value="code">{{ stateName }}</option>
    </select>
</template>

<script>
export default {
    name: 'StateSelector',

    data() {
        return {
            componentModel: this.boundObject,
            states: {
                'AL': 'Alabama',
                'AK': 'Alaska',
                'AB': 'Alberta',
                'AS': 'American Samoa',
                'AZ': 'Arizona',
                'AR': 'Arkansas',
                'CA': 'California',
                'CO': 'Colorado',
                'CT': 'Connecticut',
                'DE': 'Delaware',
                'DC': 'District of Columbia',
                'FL': 'Florida',
                'GA': 'Georgia',
                'GU': 'Guam',
                'HI': 'Hawaii',
                'ID': 'Idaho',
                'IL': 'Illinois',
                'IN': 'Indiana',
                'IA': 'Iowa',
                'KS': 'Kansas',
                'KY': 'Kentucky',
                'LA': 'Louisiana',
                'ME': 'Maine',
                'MH': 'Marshall Islands',
                'MD': 'Maryland',
                'MA': 'Massachusetts',
                'MI': 'Michigan',
                'FM': 'Micronesia',
                'AE': 'Military – Europe',
                'AP': 'Military – Pacific',
                'AA': 'Military - The Americas',
                'MN': 'Minnesota',
                'MS': 'Mississippi',
                'MO': 'Missouri',
                'MT': 'Montana',
                'NE': 'Nebraska',
                'NV': 'Nevada',
                'NH': 'New Hampshire',
                'NJ': 'New Jersey',
                'NM': 'New Mexico',
                'NY': 'New York',
                'NC': 'North Carolina',
                'ND': 'North Dakota',
                'MP': 'Northern Mariana Islands',
                'NT': 'Northwest Territory',
                'OH': 'Ohio',
                'OK': 'Oklahoma',
                'ON': 'Ontario',
                'OR': 'Oregon',
                'PW': 'Palau',
                'PA': 'Pennsylvania',
                'PR': 'Puerto Rico',
                'RI': 'Rhode Island',
                'SC': 'South Carolina',
                'SD': 'South Dakota',
                'TN': 'Tennessee',
                'TX': 'Texas',
                'UT': 'Utah',
                'VT': 'Vermont',
                'VA': 'Virginia',
                'VI': 'Virgin Islands',
                'WA': 'Washington',
                'WV': 'West Virginia',
                'WI': 'Wisconsin',
                'WY': 'Wyoming',
            },
        }
    },

    mounted() {
        if (this.changeHandler) {
            this.$refs.select.addEventListener('change', this.changeHandler)
        }
    },

    beforeUnmount() {
        if (this.changeHandler && this.$refs.select) {
            this.$refs.select.removeEventListener('change', this.changeHandler)
        }
    },

    props: {
        boundObject: {
            type: Object,
            default: null,
        },
        boundProperty: {
            type: String,
            default: 'state',
        },
        cssClass: {
            type: String,
            default: '',
        },
        changeHandler: {
            type: Function,
            required: false,
        },
        elementId: {
            type: String,
            default: 'state',
        },
    },
}
</script>

<style scoped>

input[select] {
    width: 40% !important;
}

</style>